module.exports = __webpack_public_path__ + "img/12.010ab470.jpg";